// api/planpage.js

const API_BASE_URL = process.env.REACT_APP_API_URL ||'https://stage.getrevibe.app/api';

export const fetchSubscriptions = async () => {
  const response = await fetch(`${API_BASE_URL}/subscriptions?sortOrder=desc&page=1&limit=10&search=`);
  if (!response.ok) throw new Error('Failed to fetch subscriptions');
  const data = await response.json();

  return data.data.map(sub => ({
    id: sub._id,
    title: sub.title,
    duration: `${sub.duration_value} ${sub.duration_unit}${sub.duration_value > 1 ? 's' : ''}`,
    originalPrice: sub.mrp,
    discountedPrice: sub.price,
    features: sub.features.length > 0 ? sub.features : ['No features listed'],
    type: 'workout'
  }));
};

export const fetchAddOns = async () => {
  const response = await fetch(`${API_BASE_URL}/add-ons?sortOrder=desc&page=1&limit=10&search=`);
  if (!response.ok) throw new Error('Failed to fetch add-ons');
  const data = await response.json();

  return data.addOns.map(addon => {
    let features = [];
    if (addon.description && addon.description.trim()) {
      features = addon.description
        .split(/[.\n]+/)
        .map(f => f.trim())
        .filter(f => f.length > 0 && !f.includes('http'));
    }
    if (features.length === 0) features = ['No features listed'];

    return {
      id: addon._id,
      title: addon.name,
      originalPrice: addon.mrp || addon.price,
      discountedPrice: addon.price,
      features,
      type: 'diet'
    };
  });
};